<script>
	import thumb_WPNWItsrqMU from '$lib/Components/Youtube/images/WPNWItsrqMU.jpg?w=610';

	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
</script>

<Section>
	<p>
		The first step of <a href="/about-indow/how-to-order"
			>getting cost information</a
		> for Indow inserts is measuring your windows. That’s because we can’t provide
		accurate pricing for your window insert without your window measurements, including
		frame step. But what is a frame step?
	</p>
	<p>
		We’ve explained this measurement as a flat surface extending out from your
		window (there can be multiple). Or, a flat place parallel with the floor
		where you’ll place your insert…
	</p>
	<p>
		But we think this video best explains what a frame step is and why it’s so
		important in the assessment of your windows for the suitability of our
		product:
	</p>
	<Youtube posterImageSrc={thumb_WPNWItsrqMU} videoId="WPNWItsrqMU" />
	<p>
		For more measurement and ordering information, visit our <a
			href="/about-indow/how-to-order">How to Order page</a
		>.
	</p>
</Section>
